import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    id: "como-funciona",
    class: "how-it-works"
};
var _hoisted_2 = { class: "row justify-content-center" };
var _hoisted_3 = { class: "col-12 col-md-1" };
var _hoisted_4 = { class: "d-flex align-items-center justify-content-center h-75" };
var _hoisted_5 = { class: "col-12 col-md-1" };
var _hoisted_6 = { class: "d-flex align-items-center justify-content-center h-75" };
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeHowwork',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-center" }, "¿Como funciona?", -1)),
                _createElementVNode("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"step-data col-12 col-md-3 col-xl-2\"><div class=\"d-flex justify-content-center\"><div class=\"d-flex flex-column align-items-center w-75\"><div class=\"icon-wrapper\"><img class=\"img-fluid\" src=\"/imagenes/isotipo-only.svg\"></div><h3 class=\"text-center mt-3\">Elije un plan</h3></div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(FontAwesomeIcon), {
                                icon: ['fas', 'arrow-right'],
                                class: "d-none d-md-block"
                            }),
                            _createVNode(_unref(FontAwesomeIcon), {
                                icon: ['fas', 'arrow-down'],
                                class: "d-block d-md-none"
                            })
                        ])
                    ]),
                    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"step-data col-12 col-md-3 col-xl-2\"><div class=\"d-flex justify-content-center\"><div class=\"d-flex flex-column align-items-center w-75\"><div class=\"icon-wrapper\"><img class=\"img-fluid\" src=\"/imagenes/cpu.svg\"></div><h3 class=\"text-center mt-3\">Confirma tu suscripción</h3></div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(FontAwesomeIcon), {
                                icon: ['fas', 'arrow-right'],
                                class: "d-none d-md-block"
                            }),
                            _createVNode(_unref(FontAwesomeIcon), {
                                icon: ['fas', 'arrow-down'],
                                class: "d-block d-md-none"
                            })
                        ])
                    ]),
                    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"step-data last col-12 col-md-3 col-xl-2\"><div class=\"d-flex justify-content-center\"><div class=\"d-flex flex-column align-items-center w-75\"><div class=\"icon-wrapper\"><img class=\"img-fluid\" src=\"/imagenes/tv.svg\"></div><h3 class=\"text-center mt-3\">Accede a tu perfil</h3></div></div></div>", 1))
                ])
            ]));
        };
    }
});
